import React from "react";
import "./navMain.css";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { ReactComponent as Logo } from "./logo.svg";
import {Link} from "react-router-dom";


function NavMain() {

    return(
        <div className="navigationContainer" role="navigation">


            <Navbar collapseOnSelect expand="xl" bg="{background-color}" variant="dark" id="mobile">
                
                <Navbar.Toggle aria-controls="responsive-navbar-nav" id="menuButtonIcon" />

                <div id="mobileTitle">
                    <div>Bingham Inlay Arts</div>
                </div>

                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="dropdownLinks">
                        <Nav.Link className="nav-link" href="/" id="galleryMobileLink">Gallery</Nav.Link>
                        <Nav.Link className="nav-link" href="/custom" id="customMobileLink">Custom</Nav.Link>
                        <Nav.Link className="nav-link" href="/videos" id="videosMobileLink">Videos</Nav.Link>
                        <Nav.Link className="nav-link" href="/techniques" id="tecniquesMobileLink">Tecniques</Nav.Link>
                        <Nav.Link className="nav-link" href="/bio" id="bioMobileLink">Biography</Nav.Link>
                        <Nav.Link className="nav-link" href="/contact" id="contactMobileLink">Contact</Nav.Link>
                        <br></br>
                        <br></br>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>

            <span className="title">
                <div>Bingham Inlay Arts</div>
            </span>

            <div className="links">
                <Link to="/" style={{ textDecoration: "none" }} className="link" id="galleryDesktopLink" >Gallery</Link>
                <Link to="/custom" style={{ textDecoration: "none" }} className="link" id="customDesktopLink" >Custom</Link>
                <Link to="/videos" style={{ textDecoration: "none" }} className="link" id="videoDesktopLink" >Videos</Link>
                <Link to="/techniques" style={{ textDecoration: "none" }} className="link" id="tecniquesDesktopLink" >Tecniques</Link>
                <Link to="/bio" style={{ textDecoration: "none" }} className="link" id="bioDesktopLink" >Bio</Link>
                <Link to="/contact" style={{ textDecoration: "none" }} className="link" id="contactDesktopLink" >Contact</Link>
            </div>
        </div>
    )
}

export default NavMain;